<template>
  <ServicePageLayout
    title="Smart Level"
    subtitle="ระบบติดตามระดับน้ำ"
    icon="mdi-waves-arrow-up"
    icon-color="info"
    breadcrumb="Operations"
  />
</template>

<script>
import ServicePageLayout from '@/components/layout/ServicePageLayout.vue'

export default {
  name: 'SmartLevelView',
  components: {
    ServicePageLayout,
  },
}
</script>
